import { FormGroupHeader } from "@/components/shared";
import { FetchCostDetailsQueryVariables, FetchCostDetailsQuery, Tender, FetchCostDetailsDocument } from "@/graphql/__generated__/graphql";
import { EditTenderContext } from "@/layouts/EditTenderLayout";
import { useTranslation } from "react-i18next";
import { useOutletContext, useParams } from "react-router-dom";
import { MarginErosionVisualiserComponent } from "./Components";
import { Card } from "@/components/ui/card";
import { useQuery } from "@apollo/client/react";

/**
 * Page component that displays analytics for a tender
 * @returns A page component with analytics components
 */
function AnalyticsComponent() {
  const { t } = useTranslation();
  const { tenderID } = useParams<{ tenderID: string }>();
  const { tenderByIdData } = useOutletContext<EditTenderContext>();
  const tenderData = tenderByIdData?.fetchTenderById;

  const { data: costDetailsData } = useQuery<FetchCostDetailsQuery, FetchCostDetailsQueryVariables>( FetchCostDetailsDocument, {
    variables: {
      tenderId: Number(tenderID)
    }
  });

  const listOfComponents = [
    {
      id: "margin-erosion",
      component: <MarginErosionVisualiserComponent tenderData={tenderData as Tender} costDetails={costDetailsData?.fetchCostDetails ?? []} />,
    }
  ];

  return (
    <div>
      <FormGroupHeader
        title={t("edittender.analytics.title")}
        className="pr-4 pl-2"
      />
      <div className="flex flex-col gap-4 pb-[300px] pr-4 pl-2">
        {listOfComponents.length > 0 ? (
          listOfComponents.map(({ id, component }) => (
            <div key={id}>
              {component}
            </div>
          ))
        ) : (
          <Card className="text-sm p-4 text-center">{t("edittender.analytics.noanalytics")}</Card>
        )}
      </div>
    </div>
  );
}

export default AnalyticsComponent;
